// extracted by mini-css-extract-plugin
export var root = "+yup";
export var rootAuthor = "_60+G";
export var rootAuthorLink = "+eDg";
export var rootAuthorSocials = "R-5R";
export var rootAuthorSocialsLink = "_9G6v";
export var rootContent = "_89q-";
export var rootContentHead = "Amj7";
export var rootDescription = "dvM1";
export var rootIcon = "zaWB";
export var rootImage = "ivXK";
export var rootPicture = "Fjkr";
export var rootRole = "IeHS";
export var rootVerified = "v6dN";
export var rootVerifiedIcon = "DrSr";